import React, { type FC, useState } from 'react';
import classnames from 'classnames';
import styles from './Poll.module.css';
import { type IPollChoice, type IPollQuestion } from './records';

interface Props {
  question: IPollQuestion;
  selectedChoiceId?: string;
  onSelectChoice: (choice: IPollChoice) => void;
}

const StarRating: FC<Props> = ({
  question,
  selectedChoiceId,
  onSelectChoice,
}) => {
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);
  const selectedChoiceIndex = question.choices.findIndex(
    c => c.id === selectedChoiceId
  );

  const isSelected = (index: number): boolean => {
    return hoverIndex === null
      ? index <= selectedChoiceIndex
      : index <= hoverIndex;
  };

  return (
    <>
      <div className={styles.starRating}>
        {question.choices
          .map((choice: IPollChoice, index: number) => (
            <div
              key={choice.id || index}
              onClick={() => onSelectChoice(choice)}
              onTouchStart={() => onSelectChoice(choice)}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
              className={classnames(styles.star, {
                [styles.starSelected]: isSelected(index),
              })}
            >
              <i
                className={classnames('fa-star', {
                  'fa-regular': !isSelected(index),
                  'fa-solid': isSelected(index),
                })}
              />
            </div>
          ))
          .toArray()}
      </div>
      <div className={`${styles.labels} ${styles.starRatingLabels}`}>
        <span className={styles.lowLabel}>{question.low_label}</span>
        <span className={styles.highLabel}>{question.high_label}</span>
      </div>
    </>
  );
};

export default StarRating;
